import React from 'react'
import PropTypes from 'prop-types'
import { Table } from 'semantic-ui-react'
import { Field } from 'redux-form/immutable'
import { SemanticInputMask } from '../FormComponents'
import { maskCurrency } from '../../utils/masks'
import { required } from '../../utils/validations'

const RenderFormValoresFP = ({ mes, fields }) => {
  return fields.map((valor_fp, index) => (
    <Table.Cell key={index}>
      <Field fluid
        name={`${valor_fp}.valor_fp`}
        placeholder={maskCurrency.placeholder}
        mask={maskCurrency.mask()}
        validate={[required]}
        component={SemanticInputMask}
        label='kWh'
        tabIndex={12 + mes}
      />
    </Table.Cell>
  ))
}

RenderFormValoresFP.propTypes = {
  mes: PropTypes.number,
  fields: PropTypes.object,
  loading: PropTypes.bool,
}

export default RenderFormValoresFP
